<template>
    <div class="sr-input-label">
        {{ label }}
        <div v-if="required" class="required-indicator">*</div>
    </div>
</template>
<script>
export default {
    name: 'SrInputLabel',
    props: {
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
